import { ActionTree, ActionContext } from 'vuex';
import ApiService from '@/core/services/ApiService';

// eslint-disable-next-line import/no-cycle
import { RootState } from '@/store';

import { State } from './state';
import { Mutations } from './mutations';
import { EstimatedValuesMutationTypes } from '@/core/enums/EstimatedValues/Mutations';
import { EstimatedValuesActionTypes } from '@/core/enums/EstimatedValues/Actions';
import { Mutations as vehicleMutation } from '@/store/modules/Vehicle/mutations';
import { LinkTypes } from '@/core/enums/Links';
import axios from 'axios';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [EstimatedValuesActionTypes.GET_ESTIMATED_VALUES](
    { commit }: AugmentedActionContext,
    payload: number
  ): any;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [EstimatedValuesActionTypes.GET_ESTIMATED_VALUES](context, payload: any) {
    try {
      const data = await axios.post(LinkTypes.GET_ESTEMATED_VALUE, payload);
      const defaultData = {old_max: 0, old_min: 0}
      context.commit(EstimatedValuesMutationTypes.SET_ESTIMATED_VALUES, data.data.data.value ? data.data.data.value : defaultData);
        let car_value = context.rootState.vehicles.vehicle.car_values;
        let local_value = 0;
        let storage = window.localStorage.getItem('customer_detatils')
        if(storage) {
          let parse = JSON.parse(storage)
          local_value = parseFloat(parse.car_values)
        }
        
        if(context.rootState.vehicles.vehicle.is_new == 1) {
          if(local_value < parseFloat(data.data.data.value.new_min) || local_value > parseFloat(data.data.data.value.new_min))
            car_value = parseFloat(data.data.data.value.new_min)

          if(local_value > parseFloat(data.data.data.value.new_min) && local_value < parseFloat(data.data.data.value.new_max))
            car_value = local_value
        }
        
        if(context.rootState.vehicles.vehicle.is_new == 2) {
          if(local_value < parseFloat(data.data.data.value.old_min) || local_value > parseFloat(data.data.data.value.old_min)) {
            car_value = parseFloat(data.data.data.value.old_min)
          }
            

          if(local_value > parseFloat(data.data.data.value.old_min) && local_value < parseFloat(data.data.data.value.old_max)) {
            car_value = local_value
          }
            
        }
        
        if(!local_value)
          if(context.rootState.vehicles.vehicle.is_new == 1) context.rootState.vehicles.vehicle.car_values = parseFloat(data.data.data.value.new_min)
          else context.rootState.vehicles.vehicle.car_values = parseFloat(data.data.data.value.old_min)
        else {
          context.rootState.vehicles.vehicle.car_values = car_value
        }
        
    }
    catch(err) {
      console.log(err)
    }
  },
};
